import client from 'data/client';
import { CDError } from 'utils/error';

export type Variables = {
  orderId: string;
};

export type ResponseStatus = {
  status: string;
};

export const printOrderAction = async ({ orderId }: Variables) => {
  try {
    const { data } = await client.post<ResponseStatus>(
      `/orders/history/${orderId}/print`,
    );
    return data;
  } catch (error) {
    // @ts-ignore
    throw new CDError(error.toString());
  }
};
